import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { API } from "../APICalls";
import FileUploader from "../components/FileUploader";

export default function AddRaffle(){


    document.getElementsByTagName("body")[0].classList.remove("login-page");
    document.getElementsByTagName("body")[0].classList.add("sidebar-mini");

    let navigate = useNavigate();

    const [name, setName] = useState('');
    const [bench, setBench] = useState('');
    const [winners, setWinners] = useState('');
    const [participants, setParticipants] = useState('');
    const [fileId, setFileId] = useState(null);

    const [nameError, setNameError] = useState(false);
    const [benchError, setBenchError] = useState(false);
    const [winnersError, setWinnersError] = useState(false);
    const [participantsError, setParticipantsError] = useState(false);


    const fileUploaded = (response) => {
        setFileId(response.Id);
    };

    useEffect(() => {
        if(fileId != null)
        {
            API.GetFileAnalysis(fileId).then((response) =>{
                if(response.ok)
                {
                    response.json().then((data) => {
                        setParticipants(data.NLines);
                    });
                }
                else{
                    alert("Token is not valid");
                }
            })
            .catch(() =>
            {
                alert("Cannot connect to LebenRaffle API");
            });
        }
    }, [fileId]);

    const saveRaffle = (event) => {
        event.preventDefault();


        // Reset Errors
        var errors = false;
        setNameError(false);
        setWinnersError(false);
        setBenchError(false);
        setParticipantsError(false);


        // Check Errors
        if(name == null || name == '')
        {
            errors |= true;
            setNameError(true);
        }
        if(winners == null || winners == '' || winners < 1)
        {
            errors |= true;
            setWinnersError(true);
        }
        if(bench == null || bench == '' || bench < 0)
        {
            errors |= true;
            setBenchError(true);
        }

        if(participants == null || participants == '' || participants < 1)
        {
            errors |= true;
            setParticipantsError(true);
        }


        //Save form
        if(!errors)
        {

            API.CreateRaffle(name, winners, participants, bench, fileId).then((response) => {
                if(response.ok){
                    navigate("/raffles");
                }
                else{
                    alert("Token is not valid");
                }
            })
            .catch(() =>
            {
                alert("Cannot connect to LebenRaffle API");
            });
        }

    }
    

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Crear sorteo</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                        <li className="breadcrumb-item active">Crear sorteo</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </div>
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card card-primary card-outline">
                                <div className="card-header">
                                    <h5 className="m-0">Detalles</h5>
                                </div>
                                <div className="card-body">
                                    <form onSubmit={saveRaffle}>
                                        <div class="form-group">
                                            <label for="exampleInputEmail1">Nombre</label>
                                            <input type="text" class="form-control" id="exampleInputEmail1" value={name} onChange={e => setName(e.target.value)} placeholder="Nuevo sorteo" />
                                            {nameError ? (
                                                <span id="exampleInputEmail1-error" class="small text-danger">Este campo es obligatorio</span>
                                            ) : (
                                                <></>
                                            )}
                                        </div>
                                        <div class="form-group">
                                            <label for="exampleInputPassword1">Número de participantes <small className="text-danger">Sin puntos ni comas</small></label>
                                            <input type="number" class="form-control" id="exampleInputPassword1" value={participants} onChange={e => setParticipants(e.target.value)} />
                                            {participantsError ? (
                                                <span id="exampleInputEmail1-error" class="small text-danger">Este campo es obligatorio y debe ser un número mayor que 0</span>
                                            ) : (
                                                <></>
                                            )}
                                        </div>
                                        <div class="form-group">
                                            <label for="exampleInputPassword1">Número de ganadores</label>
                                            <input type="number" class="form-control" id="exampleInputPassword1" value={winners} onChange={e => setWinners(e.target.value)} />
                                            {winnersError ? (
                                                <span id="exampleInputEmail1-error" class="small text-danger">Este campo es obligatorio y debe ser un número mayor que 0</span>
                                            ) : (
                                                <></>
                                            )}
                                        </div>
                                        <div class="form-group">
                                            <label for="exampleInputPassword1">Número de suplentes</label>
                                            <input type="number" class="form-control" id="exampleInputPassword1" value={bench} onChange={e => setBench(e.target.value)} />
                                            {benchError ? (
                                                <span id="exampleInputEmail1-error" class="small text-danger">Este campo es obligatorio.</span>
                                            ) : (
                                                <></>
                                            )}
                                        </div>

                                        <FileUploader onFileUploadDone={fileUploaded} />

                                    <button type="submit" className="btn btn-primary">Guardar</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}